import { app } from '../../../../bootstrap/core';
import { ticketTableComponent } from './ticketTable.component';
import {
  TicketTableReceivingColumns,
  TicketTableTransferringColumns,
  TicketTablePagination,
  TicketTableFilterModifier,
} from './ticketTable.constants';
import { TicketTableService } from './ticketTable.service';

import './plugins/sortable/sortable';

// Templates
import ticketTableReceivingTemplate from './partials/receiving.tpl.html';
import ticketTableTransferringTemplate from './partials/transferring.tpl.html';

app
  .component('ticketTable', ticketTableComponent)
  .value('TicketTableReceivingColumns', TicketTableReceivingColumns)
  .value('TicketTableTransferringColumns', TicketTableTransferringColumns)
  .constant('TicketTablePagination', TicketTablePagination)
  .constant('TicketTableFilterModifier', TicketTableFilterModifier)
  .service('ticketTableService', TicketTableService)
  .value('ticketTableReceivingTemplate', ticketTableReceivingTemplate)
  .value('ticketTableTransferringTemplate', ticketTableTransferringTemplate);
